export default __webpack_public_path__ + "static/media/coins.7918e3e1.svg";